module.exports = function (angular, app) {
    var granularity = require('../../../lib/deep-query-api/lib/druid/granularity'),
        durationFromGranularity = granularity.durationFromGranularity,
        autoGranularityFromIntervals = granularity.autoGranularityFromIntervals;

    var MAX_DURATION_HISTORICAL_DEFAULT_PERIODS = 7 * 86400000,
        DEFAULT_HISTORICAL_DURATION_PERIODS = 12,
        LONG_TERM_HISTORICAL_DURATION_PERIODS = 3,
        MIN_REFRESH_RATE = 1000;

    var collections = require('../../../lib/deep-query-api/lib/collections'),
        map = collections.map,
        each = collections.each,
        compact = collections.compact;

    var averages = require('../historical').averages;

    var isArray = angular.isArray;

    var defaultOptions = {
        splits: true,
        granularity: "all",
        queryAt: "query",
        intervalAt: "query.intervals",
        orderAt: "query.order",
        offsetAt: "query.offset",
        refreshRate: 0,
        refreshControl: null
    };

    String.prototype.replaceAll = function (search, replacement) {
        var target = this;
        return target.replace(new RegExp(search, 'g'), replacement);
    };

    app.factory('DeepQueryStore', ['$rootScope', '$window', '$http', '$q', '$timeout', '$sessionStorage', 'deepQuerySerializer', 'deepQueryData', 'RelativeInterval', 'Duration', 'regexpEscape', 'deepQueryContextService', '$localStorage', 'organizationsService', 'externalApiService',
        function deepQueryStoreFactory($rootScope, $window, $http, $q, $timeout, $sessionStorage, deepQuerySerializer, deepQueryData, RelativeInterval, Duration, regexpEscape, deepQueryContextService, $localStorage, organizationsService, externalApiService) {

            function DeepQueryStore(scope, options) {
                var store = this,
                    gBindId = 0;

                this.nextId = function () {
                    return ++gBindId;
                };

                this.handlers = {};
                this.scope = scope;
                this.options = options = angular.extend({}, defaultOptions, options || {});
                this.filter = {timestamp: null, dimensions: null};
                this._pendingRefresh = $q.resolve();
                this.tableState = {};

				this.initialized = false;

                resetPromises(this);

                var destroy = this.destroy = function () {
                    store.handlers = null;

                    if (store._refreshTimeout != null) {
                        $timeout.cancel(store._refreshTimeout);

                        store._refreshTimeout = null;
                    }

                    killRefreshTimer(store);
                    resetPromises(store);
                };

                if (options.refreshRate) {
                    startRefreshTimer(store);
                }

                scope.$on('$destroy', destroy);
            }

            var proto = DeepQueryStore.prototype;

            proto.bind = function (callback) {
                var id = this.nextId();

                this.handlers[id] = callback;

                return id;
            };

            proto.unbind = function (id) {
                if (!this.handlers) {
                    return;
                }

                delete this.handlers[id];
            };

            proto.setTableState = function (state) {
                this.tableState = state;
            };

            proto.getTableState = function () {
                return this.tableState;
            };

            proto.setCustomMetrics = function (metrics, forceRefresh = false) {
                let isEqual = angular.equals(metrics, this.options.customMetrics);

                this.options.customMetrics = metrics;

                if (!this.initialized || !isEqual || forceRefresh) {
                    this.refresh();
                }
            };

            proto.getCustomMetrics = function () {
                return this.options.customMetrics;
            };

            proto.setCustomFilters = function (filters) {
                this.options.customFilters = filters;

                this.refresh();
            };

            proto.getQuery = function () {
                let store = this;
                let options = store.options,
                    scope = store.scope,
                    intervals = scopeEval(scope, options.intervalAt),
                    order = scopeEval(scope, options.orderAt),
                    offset = scopeEval(scope, options.offsetAt),
                    query = obtainQuery(scope, options.queryAt, options.customMetrics, options.customFilters, intervals, options.splits, options.granularity, store.filter, order, offset, options.context);
                return query;
            };

            proto.getCurlQuery = function () {

                function checkFilters(filters) {
                    if (filters) {
                        !filters.negative ? delete filters.negative : null;
                        !filters.isLookup ? delete filters.isLookup : null;
                        delete filters.$$hashKey;

                        if (filters.hasOwnProperty("children")) {
                            filters.children.forEach(function (metric) {
                                checkFilters(metric)
                            })
                        }
                    }
                }

                function deleteUnnecessaryValues(m) {
                    m.filter != null ? checkFilters(m.filter) : delete m.filter;

                    if (m.hasOwnProperty('values')) {
                        m.values.compare == null ? delete m.values.compare : null;
                    }

                    !m.isLookup ? delete m.isLookup : null;
                    delete m.displayType;
                    delete m.format;
                    delete m.$$hashKey;
                }

                let store = this;
                let options = store.options,
                    scope = store.scope,
                    intervals = scopeEval(scope, options.intervalAt),
                    order = scopeEval(scope, options.orderAt),
                    offset = scopeEval(scope, options.offsetAt),
                    query = obtainQuery(scope, options.queryAt, options.customMetrics, options.customFilters, intervals, options.splits, options.granularity, store.filter, order, offset, options.context);

                //clean query
                delete query.context;
                query.conditions == null ? delete query.conditions : null;

                if (query.hasOwnProperty("filters")) {
                    query.filters != null ? checkFilters(query.filters) : delete query.filters;
                }

                query.metrics.forEach(function (metric) {
                    if (isArray(metric.args)) {
                        metric.args.forEach(function (m) {
                            delete m._ref;
                            deleteUnnecessaryValues(m)
                        })
                    }

                    deleteUnnecessaryValues(metric);
                });

                if (query.hasOwnProperty("splits")) {
                    query.splits.forEach(function (split) {
                        !split.isLookup ? delete split.isLookup : null;
                    });
                }


                return query;
            };

            proto.getDruidQuery = function () {
                const query = getSerializedQuery(this);
                const streamKey = organizationsService.getSelectedOrganizationStreamKey();

                return externalApiService.queryApiPreviewRequest(query, streamKey);
            };

            proto.query = function (query) {
                return loadData(this, query);
            };

            proto.data = function () {
                return this._dataPromise || (this._dataPromise = loadData(this));
            };

            proto.selectData = function () {
                return this._selectDataPromise || (this._selectDataPromise = loadSelectData(this));
            };

            proto.createDownloadLink = function (name) {
                let requestDate = Date.now();
                name = (name || 'result').replace(/[\/\\]/g, '_');

                let options = this.options,
                    scope = this.scope,
                    intervals = scopeEval(scope, options.intervalAt),
                    order = scopeEval(scope, options.orderAt),
                    query = obtainQuery(scope, options.queryAt, options.customMetrics, options.customFilters, intervals, options.splits, options.granularity, this.filter, order);

                if (!query) {
                    return $q.resolve('');
                }

                query.top = 0x7fffffff;

                let payload = deepQuerySerializer.serialize(query);
                const from = organizationsService.getSelectedOrganizationQueryingKey();

                return deepQueryData.getCachedWithTtl({
                    payload: payload,
                    ttl: 60000,
                    ns: 'link:',
                    url: '/-/query-encode',
                    reqTime: requestDate,
					from: from,
                    funcName: 'DeepQueryStore.proto.createDownloadLink'
                }).then(function (encodedQuery) {
                    return {
                        action: '/download/' + from + '/' + encodeURIComponent(name) + '.csv',
                        query: encodedQuery.replace(/=+$/, '')
                    };
                });
            };

            proto.historicalData = function (metricIndex, metricName) {
                return this._historicalPromises[metricIndex] || (this._historicalPromises[metricIndex] = loadHistoricalData(this, metricIndex, metricName));
            };

            proto.predictionData = function (metricIndex, query, force = false) {
                if (force) {
                    return loadPredictionData(this, metricIndex, query);
                }

                return this._predictionPromises[metricIndex] || (this._predictionPromises[metricIndex] = loadPredictionData(this, metricIndex, query));
            };

            proto.clearAllFilters = function () {
                this.clearTimestampFilter();
                this.clearDimensionFilter();
            };

            proto.clearTimestampFilter = function () {
                this.filter.timestamp = null;
            };

            proto.setTimestampFilter = function (timestamp) {
                if (timestamp instanceof Date) {
                    timestamp = timestamp.toISOString();
                } else if ('number' === typeof timestamp) {
                    timestamp = new Date(timestamp).toISOString();
                }

                this.filter.timestamp = timestamp == null ? null : timestamp;
            };

            proto.clearDimensionFilter = function () {
                this.filter.dimensions = null;
            };

            proto.getDimensionFilter = function () {
                return this.filter.dimensions
            };

            proto.setDimensionFilter = function (rows, splitno) {
                var filter = this.filter,
                    dimensions = filter.dimensions,
                    splits = getNamedSplits(this).length > 0 ? getNamedSplits(this) : this.scope.$parent.query.splits;

                if (splits.length === 0) {
                    return this.clearDimensionFilter();
                }

                if ('number' === typeof splitno && splitno % 1 === 0 && splitno >= 0 && splitno < splits.length) {
                    if (dimensions == null || dimensions.type !== "and") {
                        filter.dimensions = dimensions = {type: "and", negative: false, children: []};
                    }

                    if (rows.length === 0) {
                        dimensions.children[splitno] = void 0;

                        if (compact(dimensions.children).length === 0) {
                            filter.dimensions = null;
                        }
                    } else {
                        var values, split = splits[splitno], field = split.field, name = split.name,
                            isLookup = split.isLookup;

                        if (split.regex) {
                            values = map(rows, function (row) {
								if (row[name] == null) {
									return {
										type: "eq",
										field: field,
										negative: false,
										value: null,
										isLookup: isLookup
									};
								} else {
									return {
										type: "re",
										field: field,
										negative: false,
										value: regexpEscape(row[name] || ''),
										isLookup: isLookup
									};
								}

                            });

                            dimensions.children[splitno] = (values.length === 1) ? values[0] : {
                                type: "or",
                                negative: false,
                                children: values,
                                isLookup: isLookup
                            };
                        } else {
                            values = map(rows, function (row) {
                                return row[split.name] || ''
                            });

                            dimensions.children[splitno] = (values.length === 1) ? {
                                type: "eq",
                                field: field,
                                negative: false,
                                value: values[0],
                                isLookup: isLookup
                            } : {type: "in", field: field, negative: false, values: values, isLookup: isLookup};
                        }
                    }
                } else if (rows.length === 0) {
                    filter.dimensions = null;
                } else {
                    filter.dimensions = dimensions = {type: "or", negative: false};

                    dimensions.children = map(rows, function (row) {
                        var children = map(splits, function (split) {
                            var field = split.field, value = row[split.name] || '', isLookup = split.isLookup;

                            if (split.regex) {
                                return {
                                    type: "re",
                                    field: field,
                                    negative: false,
                                    value: regexpEscape(value),
                                    isLookup: isLookup
                                };
                            } else {
                                return {
                                    type: "eq",
                                    field: field,
                                    negative: false,
                                    value: value,
                                    isLookup: isLookup
                                };
                            }
                        });

                        return children.length === 1 ? children[0] : {type: "and", negative: false, children: children};
                    });
                }
            };

            proto.refresh = function () {
                this.initialized = true;

                if (!this.handlers) {
                    return;
                }

                if (this._refreshTimeout != null) {
                    return this._refreshTimeout;
                }

                var store = this;

                refreshQueryContext(store);

                return this._refreshTimeout = $timeout().then(function () {
                    return store._pendingRefresh = synchronize(store._pendingRefresh, function () {
                        store._refreshTimeout = null;

                        if (!store.handlers) {
                            return;
                        }

                        store._dataPromise = null;
                        store._selectDataPromise = null;
                        store._historicalPromises.length = 0;
                        store._predictionPromises.length = 0;

                        return handleBound(store);
                    });
                });
            };

            proto.sendWidgetStatistics = function (data) {
                let thisQuery = JSON.stringify(this.getQuery());

                if (thisQuery && "object" === typeof data) {
                    data.query = thisQuery.replaceAll("{", "<").replaceAll("}", ">").replaceAll(":", "|");

                    $rootScope.$broadcast("widget-statistics", data);
                }
            };

            var userAttentionActive = true;
            var body = $window.document.getElementsByTagName('body')[0];

            each([
                [$window, 'focus', userAttentionEngaged],
                [$window, 'scroll', userAttentionEngaged],
                [$window, 'resize', userAttentionEngaged],
                [body, 'mousemove', userAttentionEngaged],
                [body, 'mousedown', userAttentionEngaged],
                [body, 'keydown', userAttentionEngaged],
                [$window, 'blur', userAttentionDisengaged],
                [$window, 'pagehide', userAttentionDisengaged],
                [$window, 'pageshow', userAttentionEngaged],
                [$window, 'focusin', userAttentionEngaged],
                [$window, 'focusout', userAttentionDisengaged]
            ], function (args) {
                args[0].addEventListener(args[1], args[2], false);
            });

            return DeepQueryStore;

            function getNamedSplits(store) {
                var splits = (scopeEval(store.scope, store.options.queryAt) || {}).splits || [],
                    autoName = deepQuerySerializer.autoNameGenerator('split');

                return map(splits, function (split) {
                    return {name: autoName(split), field: split.field, regex: split.regex, isLookup: split.isLookup};
                });
            }

            function userAttentionEngaged() {
                userAttentionActive = true;
            }

            function userAttentionDisengaged() {
                userAttentionActive = false;
            }

            function killRefreshTimer(store) {
                var promise = store._autoUpdate;

                if (promise !== void 0) {
                    store._autoUpdate = void 0;

                    $timeout.cancel(promise);
                }
            }

            function startRefreshTimer(store) {
                var options = store.options,
                    refreshControl = options.refreshControl,
                    refreshRate = options.refreshRate;

                if ('string' === typeof refreshRate) {
                    refreshRate = +scopeEval(store.scope, refreshRate);
                }

                if (!isFinite(refreshRate) || refreshRate < MIN_REFRESH_RATE) {
                    refreshRate = MIN_REFRESH_RATE;
                }

                function restartTimer() {
                    if (store._autoUpdate !== void 0) {
                        startRefreshTimer(store);
                    }
                }

                store._autoUpdate = $timeout(function () {
                    if (userAttentionActive && (refreshControl == null || scopeEval(store.scope, refreshControl))) {
                        store.refresh().then(restartTimer, restartTimer);
                    } else {
                        restartTimer();
                    }
                }, refreshRate);
            }

            function getSerializedQuery(store) {
                var options = store.options,
                    scope = store.scope,
                    intervals = scopeEval(scope, options.intervalAt),
                    order = scopeEval(scope, options.orderAt),
                    offset = scopeEval(scope, options.offsetAt),
                    query = obtainQuery(scope, options.queryAt, options.customMetrics, options.customFilters, intervals, options.splits, options.granularity, store.filter, order, offset, options.context);

                return deepQuerySerializer.serialize(query);
            }

            function findMetricByType(metrics, metricType) {
                const metricsByType = _.filter(metrics, metric => metric.type === metricType);

                if (metricsByType && metricsByType.length) {
                    return metricsByType;
                }

                const argsMetrics = _.filter(metrics, metric => metric.hasOwnProperty("args"));

                if (argsMetrics) {
                    let argsFromMetrics = [];
                    argsMetrics.forEach(metric => {
                        argsFromMetrics = _.union(argsFromMetrics, metric.args);
                    });

                    if (argsFromMetrics.length) {
                        return findMetricByType(argsFromMetrics, metricType);
                    }
                }

                return [];
            }

            function isMongoCacheActive(store) {
                let mongocache = store.options.mongocache;

                const intervals = scopeEval(store.scope, store.options.intervalAt);
                if (intervals && intervals.hasOwnProperty("source") && intervals.source === "yesterday") {
                    return mongocache;
                }

                const thetaSketchMetrics = findMetricByType(store.options.customMetrics, "thetaSketch");
                if (thetaSketchMetrics.length) {
                    mongocache = false;
                }

                const divideMetrics = findMetricByType(store.options.customMetrics, "/");
                if (divideMetrics.length) {
                    const countMetrics = findMetricByType(store.options.customMetrics, "count");

                    if (!countMetrics.length) {
                        mongocache = false;
                    }
                }

                return mongocache;
            }

            function loadData(store, adHocQuery) {
                let requestDate = Date.now();
                var options = store.options,
                    scope = store.scope,
                    intervals = scopeEval(scope, options.intervalAt),
                    order = scopeEval(scope, options.orderAt),
                    offset = scopeEval(scope, options.offsetAt),
                    query = adHocQuery || obtainQuery(scope, options.queryAt, options.customMetrics, options.customFilters, intervals, options.splits, options.granularity, store.filter, order, offset, options.context);

                if (!query) return $q.resolve([]);

                query.mongocache = isMongoCacheActive(store);

                return deepQueryData.getCachedWithTtl({
                    payload: deepQuerySerializer.serialize(query),
                    ttl: ttlFromIntervals(query.intervals),
                    reqTime: requestDate,
					from: organizationsService.getSelectedOrganizationQueryingKey(),
                    funcName: 'DeepQueryStore.loadData'
                });
            }

            function loadSelectData(store, adHocQuery) {
                let requestDate = Date.now();
                var options = store.options,
                    scope = store.scope,
                    intervals = scopeEval(scope, options.intervalAt),
                    order = scopeEval(scope, options.orderAt),
                    offset = scopeEval(scope, options.offsetAt),
                    query = adHocQuery || obtainQuery(scope, options.queryAt, options.customMetrics, options.customFilters, intervals, options.splits, options.granularity, store.filter, order, offset, options.context);

                if (!query) return $q.resolve([]);

                query.mongocache = options.hasOwnProperty("mongocache") ? options.mongocache : false;

                return deepQueryData.getCachedWithTtl({
                    payload: deepQuerySerializer.serialize(query),
                    ttl: 3600000,
                    url: '/-/select/',
                    reqTime: requestDate,
					from: organizationsService.getSelectedOrganizationQueryingKey(),
					funcName: 'DeepQueryStore.loadSelectData'
                });
            }

            function loadHistoricalData(store, metricIndex, metricName) {
                let requestDate = Date.now();
                var options = store.options,
                    scope = store.scope,
                    granularity = options.granularity,
                    interval = scopeEval(scope, options.intervalAt),
                    refdate = new Date(),
                    dates = interval.toDates(refdate).map(function (date) {
                        return new Date(Math.round(date.getTime() / 60000) * 60000);
                    }),
                    duration = dates[1].getTime() - dates[0].getTime(),
                    historicalDurationPeriods = duration <= MAX_DURATION_HISTORICAL_DEFAULT_PERIODS ? DEFAULT_HISTORICAL_DURATION_PERIODS : LONG_TERM_HISTORICAL_DURATION_PERIODS,
                    historicalInterval = new RelativeInterval([dates[1].getTime() - historicalDurationPeriods * duration, dates[1]]),
                    periodpoints;

                if (granularity === 'all') {
                    periodpoints = 1;
                } else {
                    granularity = durationFromGranularity(autoGranularityFromIntervals(dates));
                    periodpoints = Math.ceil(duration / granularity);
                    duration = granularity;
                }

                granularity = new Duration(duration).toString();

                let query = obtainQuery(scope, options.queryAt, options.customMetrics, options.customFilters, historicalInterval, false, granularity, store.filter);

                if (!query) {
                    return $q.resolve([]);
                }

                if (!metricName) {
                    return $q.resolve([]);
                }

                delete query.top;
                delete query.offset;

                var payload = deepQuerySerializer.serialize(query);

                return deepQueryData.getCachedWithTtl({
                    payload: payload,
                    ttl: ttlFromIntervals(query.intervals) * 2,
                    reqTime: requestDate,
					from: organizationsService.getSelectedOrganizationQueryingKey(),
                    funcName: 'DeepQueryStore.loadHistoricalData'
                }).then(function (data) {
                    return averages(data, metricName, dates[0], duration, periodpoints);
                });
            }

            function loadPredictionData(store, metricIndex, adHocQuery) {
                let requestDate = Date.now();
                var options = store.options,
                    scope = store.scope,
                    query = adHocQuery || obtainQuery(scope, options.queryAt, null, options.customFilters, scopeEval(scope, options.intervalAt), false, options.granularity, store.filter);

                if (!query) {
                    return $q.resolve([]);
                }

                delete query.top;
                delete query.offset;

                var payload = deepQuerySerializer.serialize(query);

                return deepQueryData.getCachedWithTtl({
                    payload: payload,
                    ttl: 3600000,
                    ns: 'predict:' + metricIndex + ':',
                    url: '/-/predict/' + metricIndex,
                    reqTime: requestDate,
                    funcName: 'DeepQueryStore.loadPredictionData'
                });
            }

            function checkCustomMetricExistanceByName(customMetrics, metricName) {
                return _.some(customMetrics, metric => {
                    return metric.name === metricName;
                }) || _.some(customMetrics, metric => {
                    return (metric.name === null || metric.name === "") && metric.type === metricName;
                });
            }

            function buildQueryConditions(customMetrics, obj) {
                if (!obj) {
                    return;
                }

                if (!obj.hasOwnProperty("children")) {
                    obj.ignore = !checkCustomMetricExistanceByName(customMetrics, obj["field"]);
                } else if (obj.hasOwnProperty("children")) {
                    obj.children.forEach(child => {
                        buildQueryConditions(customMetrics, child);
                    });
                }
            }

            function setIntervalDates(intervalObj,query,granularity) {
                let interval = angular.copy(intervalObj);
				let startDate = "";
				let endDate = "";
				let date = new Date();

				if(query.homePage) {
					return granularity === 'PT3600S'
							? [ moment(date.setHours(0, 0, 0, 0)).subtract(12, 'days').format("YYYY-MM-DD[T]HH:mm:ss.SSS"),
								moment(date.setHours(0, 0, 0, 0)).add(1,'days').format("YYYY-MM-DD[T]HH:mm:ss.SSS")]
							: [ moment(date.setHours(0, 0, 0, 0)).format("YYYY-MM-DD[T]HH:mm:ss.SSS"),
								moment(date.setHours(0, 0, 0, 0)).add(1,'days').format("YYYY-MM-DD[T]HH:mm:ss.SSS")];
				} else if(query.meta.realtimeEnabled){

					let duration = $sessionStorage.intervalObject.duration;
					endDate = moment(date).format("YYYY-MM-DD[T]HH:mm:ss.SSS");

					switch ($sessionStorage.intervalObject.intervalId) {
						case "last_1_seconds":
							startDate = moment(date).subtract(duration[0], duration[1]).format("YYYY-MM-DD[T]HH:mm:ss.SSS");
							break;
						case "last_minute":
							startDate = moment(date).subtract(duration[0], duration[1]).format("YYYY-MM-DD[T]HH:mm:ss.SSS");
							break;
						case "last_3_minutes":
							startDate = moment(date).subtract(duration[0], duration[1]).format("YYYY-MM-DD[T]HH:mm:ss.SSS");
							break;
						case "last_30_minutes":
							startDate = moment(date).subtract(duration[0], duration[1]).startOf('minute').format("YYYY-MM-DD[T]HH:mm:ss.SSS");
							break;
						case "last_hour":
							startDate = moment(date).subtract(duration[0], duration[1]).startOf('hour').format("YYYY-MM-DD[T]HH:mm:ss.SSS");
							break;
						case "today":
							startDate = moment(date).startOf('day').format("YYYY-MM-DD[T]HH:mm:ss.SSS");
							break;
						case "this_week":
							startDate = moment(date).startOf('week').format("YYYY-MM-DD[T]HH:mm:ss.SSS");
							break;
						case "this_month":
							startDate = moment(date).startOf('month').format("YYYY-MM-DD[T]HH:mm:ss.SSS");
							break;
						default:
							startDate = moment(date).subtract(duration[0], duration[1]).format("YYYY-MM-DD[T]HH:mm:ss.SSS");
					}
					return [startDate,endDate];
				} else if (interval.end && interval.start) {
					startDate = moment({
						years: interval.start.year,
						months: interval.start.month - 1,
						date: interval.start.mday,
						hours: 0,
						minutes: 0,
						seconds: 0,
						milliseconds: 0,
						timezone: 0
					});
					endDate = moment({
						years: interval.end.year,
						months: interval.end.month - 1,
						date: interval.end.mday,
						hours: 0,
						minutes: 0,
						seconds: 0,
						milliseconds: 0,
						timezone: 0
					}).add(1,'days');
					return [moment(startDate).format("YYYY-MM-DD[T]HH:mm:ss.SSS") , moment(endDate).format("YYYY-MM-DD[T]HH:mm:ss.SSS")];
				} else if ($sessionStorage.intervalObject && $sessionStorage.intervalObject.startDate) {
					startDate = $sessionStorage.intervalObject.startDate;
					endDate = $sessionStorage.intervalObject.endDate;
					return [moment(startDate).format("YYYY-MM-DD[T]HH:mm:ss.SSS") , moment(endDate).format("YYYY-MM-DD[T]HH:mm:ss.SSS")];
				} else {
					//TODAY
					return [moment(date.setHours(0, 0, 0, 0)).format("YYYY-MM-DD[T]HH:mm:ss.SSS") , moment(date.setHours(0, 0, 0, 0)).add(1,'days').format("YYYY-MM-DD[T]HH:mm:ss.SSS")];
				}
			}

            function checkIgnore(obj) {
                if (!obj) {
                    return true;
                }
                if (!obj.hasOwnProperty("children")) {
                    return obj.ignore;
                } else if (obj.hasOwnProperty("children")) {
                    return obj.children.map(x=>x.ignore).reduce((cur, next) => cur&&next);
                }
            }

            function obtainQuery(scope, queryAt, customMetrics, customFilters, interval, splits, granularity, filter, order, offset, context ) {
                let originalQuery = scopeEval(scope, queryAt);
                let originalQueryConditions = angular.copy(originalQuery.conditions);
				let selectedDashboard = originalQuery.homePage ? {name: 'Panel Home Page', type: 'homePage', "dashboardId": 'homePage'} : $sessionStorage.selectedDashboard || null;
	            let user = JSON.parse($window.localStorage.getItem("user"));
                buildQueryConditions(customMetrics, originalQueryConditions);

				if(!context){
					context = {
						allowAsync: true,
						// forceAsync: true
					}
				} else {
					context.allowAsync = true;
					// context.forceAsync = true;
				}

				if(selectedDashboard) {
					selectedDashboard.dashboardId = selectedDashboard.dashboardId ? selectedDashboard.dashboardId : selectedDashboard._id;
					delete selectedDashboard.query;
				}

	            context.user = {
					isDeepUser:  $sessionStorage.selectedOrganization.role === "super_admin",
		            roleInOrganization: $sessionStorage.selectedOrganization.role,
		            userId: user._id,
		            userEmail: user.email
	            }

                let group,
                    query = {
                        context: context,
                        metrics: customMetrics || originalQuery.metrics,
                        from: originalQuery.from,
                        top: originalQuery.top,
                        granularity: granularity,
                        realtime: originalQuery.meta.realtimeEnabled,
                        intervals: {
                        	dates: setIntervalDates(interval,originalQuery,granularity),
							translatedFrom: interval,
							strict: true
                        },
                        timeZoneOffset: new Date().getTimezoneOffset(),
						dashboard: selectedDashboard
                    };

                if (offset != null) {
                    query.offset = offset;
                }

                if (!query.metrics || query.metrics.length === 0 || !query.from) {
                    return;
                }

                if ('number' === typeof splits) {
                    if (isFinite(splits) && isArray(originalQuery.splits) && (group = originalQuery.splits[splits])) {
                        query.splits = [group];
                        if (!checkIgnore(originalQueryConditions)) {
                            query.conditions = originalQueryConditions;
                        }
                    }
                } else if (splits) {
                    query.splits = originalQuery.splits;

                    if (!checkIgnore(originalQueryConditions)) {
                        query.conditions = originalQueryConditions;
                    }
                }

                if (query.splits && isArray(order) && order.length !== 0) {
                    query.order = order;
                }

                let queryFilters = originalQuery.filters;

                if (filter.dimensions) {
                    queryFilters = mergeFilters(queryFilters, filter.dimensions);
                }

                if (customFilters) {
                    if (queryFilters) {
                        let customQueryFilters = angular.copy(queryFilters);
                        queryFilters = {
                            type: "and",
                            children: [customQueryFilters, customFilters],
                            negative: false
                        };
                    } else {
                        queryFilters = customFilters;
                    }
                }

                query.filters = queryFilters;

                if(originalQuery.homePage && granularity==="auto") {
					query.granularity = originalQuery.granularity;
				} else if(originalQuery.meta.realtimeEnabled && !originalQuery.homePage && (granularity ==="auto" || granularity[0] ==="P")) {
					query.granularity = $sessionStorage.intervalObject ? $sessionStorage.intervalObject.granularity : 'all';
				}

                return query;
            }

            function mergeFilters(filters, dimensionsFilter) {
                var appendFilter = compactJunctionFilter(dimensionsFilter);

                if (appendFilter) {
                    filters = joinFilters(appendFilter, filters);
                }

                return filters;
            }

            function compactJunctionFilter(filter) {
                var children = compact(filter.children);

                if (children.length !== 0) {
                    if (children.length === 1) {
                        return children[0];
                    }

                    return {type: filter.type, negative: filter.negative, children: children};
                }
            }

            function joinFilters(filter, joinedFilter) {
                if (joinedFilter) {
                    if (filter.type === 'and') {
                        filter.children.push(joinedFilter);
                    } else {
                        filter = {type: "and", negative: false, children: [filter, joinedFilter]};
                    }
                }

                return filter;
            }

            function ttlFromIntervals(interval) {
                interval = RelativeInterval(interval);

                var refdate = new Date(),
                    dates = interval.toDates(refdate),
                    deltams;

                if (interval.isRelative() || +dates[1] > +refdate) {
                    deltams = dates[1] - dates[0];

                    if (deltams <= 60999) {
                        return 1000;
                    } else if (deltams <= 86459999) {
                        return 5000;
                    } else if (deltams < 8 * 86400000) {
                        return 60000;
                    } else if (deltams < 32 * 86400000) {
                        return 300000;
                    }
                }

                return 600000;
            }

            function handleBound(store) {
                var id,
                    ret,
                    cb,
                    promises = [],
                    handlers = store.handlers;

                for (id in handlers) {
                    cb = handlers[id];

                    if (cb) {
                        try {
                            ret = cb(store);
                            if (ret && 'function' === typeof ret.then) {
                                promises.push(ret);
                            }
                        } catch (err) {
                            console.error(err);
                        }
                    }
                }

                return $q.all(promises).finally(() => {
                    resolveStoreQuery(store);
                })
            }

            function resetPromises(store) {
                store._dataPromise = $q.resolve([]);
                store._selectDataPromise = $q.resolve([]);
                store._predictionPromises = [];
                store._historicalPromises = [];
            }

            function refreshQueryContext(store) {
                store.options.context = {
                    queryId: deepQueryContextService.generatePendingQueryId(),
                    source: 'deep-panel2.0'
                }
            }

            function resolveStoreQuery(store) {
                if (store.options.hasOwnProperty('context')) {
                    deepQueryContextService.resolvePendingQueryId(store.options.context);
                }
            }
        }]);

    function scopeEval(scope, program) {
        return ('function' === typeof program) ? program(scope) : scope.$eval(program);
    }

    function synchronize(promise, callback) {
        return promise.then(callback, callback);
    }
};
